/*
 * @Description: 项目模块
 * @Version: 1.0
 * @Autor: steFan
 * @Date: 2020-03-19 14:01:03
 * @LastEditors: steFan
 * @LastEditTime: 2020-04-06 08:57:09
 */
'use strict';
import axios from 'axios';
import common from './common'; //公共js
import ElementUI from 'element-ui';
import config from './config';
import {
    Loading
} from 'element-ui';
import store from '../store/store';
import route from '../router/index'
// axios.defaults.withCredentials=true;
axios.defaults.timeout = 30 * 1000;
let loading; //定义loading变量
let baseUrl = common.getHost();
const ACCESS_TOKEN = 'access_token';
let messageInstance = null; //定义弹框
import i18n from '../il8n/index';
let lang = 'zh';

function startLoading() {
    //使用Element loading-start 方法
    if (!loading) {
        loading = Loading.service({
            lock: true,
            text: '加载中...',
            background: 'rgba(0, 0, 0, 0.3)',
        });
    }
}

function endLoading() {
    //使用Element loading-close 方法
    if (loading) {
        loading.close();
        loading = null;
    }
}

//那么 showFullScreenLoading() tryHideFullScreenLoading() 要干的事儿就是将同一时刻的请求合并。
//声明一个变量 needLoadingRequestCount，每次调用showFullScreenLoading方法 needLoadingRequestCount + 1。
//调用tryHideFullScreenLoading()方法，needLoadingRequestCount - 1。needLoadingRequestCount为 0 时，结束 loading。
let needLoadingRequestCount = 0;

export function showFullScreenLoading() {
    if (needLoadingRequestCount === 0) {
        startLoading();
    }
    needLoadingRequestCount++;
}
export function tryHideFullScreenLoading() {
    if (needLoadingRequestCount <= 0) return;
    needLoadingRequestCount--;
    if (needLoadingRequestCount === 0) {
        setTimeout(() => {
            endLoading();
        }, 300);
    }
}
// http request 拦截器
axios.interceptors.request.use(
    (config) => {
        if (i18n.locale === 'zh_CN') {
            lang = 'zh';
        } else if (i18n.locale === 'zh_HK') {
            lang = 'cht';
        } else if (i18n.locale === 'en_US') {
            lang = 'en';
        }
        config.headers = {
            'X-Frame-Options': 'SAMEORIGIN'
        };
        config.headers.contentType = 'application/json';
        config.headers.clientCode = window.clientCode;
        config.headers.pc = 1;
        config.headers.clientItem = window.childCode //子平台id字段
        config.headers.skinCode = window.theme
        config.headers.lang = lang;
        if (common.getToken()) {
            config.headers.Authorization = common.getToken();
        }
        if (config.configs.isLoading) {
            showFullScreenLoading();
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    },
);
// http response 拦截器
let self = this;
axios.interceptors.response.use(
    (response) => {
        if (response.config.configs.isLoading) {
            tryHideFullScreenLoading();
        }
        if (response.data.code == 16003) {
            common.clearToken();
            store.commit("setToken", null);
            showMesasge('账号已在其它设备登录，请重新登录');
            setTimeout(() => {
                location.reload();
            }, 600);
        } else if (response.data.code == 110009) {
            // common.clearToken();
            // sessionStorage.setItem('restraint', true)
            route.push({
            	name: 'iplimit',
                query: {
                    ip: response.data.msg,
                    custommerUrl: response.data.data.customer
                }
            })
            // showMesasge('访问被限制');
        } else {
            return response;
        }
    },
    (error) => {
        tryHideFullScreenLoading();
        //403处理    （去掉先）
        if (error.response) {
            switch (error.response.status) {
                case 503:
                    // showMesasge('系统维护中');
                    break;
                case 500:
                    // showMesasge('系统维护中');
                    break;
                case 401:
                    common.clearToken();
                    showMesasge('您的登录账户已经过期，请您重新登录');
                    break;
                    // 404请求不存在
                case 404:
                    showMesasge(error.response.data.msg);
                    break;
                    // 其他错误，直接抛出错误提示
                default:
                    showMesasge(error.response.data.msg);
            }
        }
        return Promise.resolve(error.response);
    },
);

function showMesasge(msg, type = 'error') {
    if (messageInstance) {
        //如果有已经打开的弹框就先关闭
        // messageInstance.close();
        // messageInstance = null;
    } else {
        messageInstance = ElementUI.Message({
            showClose: true,
            message: msg || '请求出错，请重试',
            type: type,
            duration: 3000,
            onClose: () => {
                messageInstance = null;
            }
        });
    }
}

export default {
    errMsg(code) {
        let msg = code;
        if (msg.includes('errorCode')) {
            msg = i18n.tc('errorCode.1000') + '(1000)';
        }
        ElementUI.Message({
            'message': msg,
            'type': 'error',
            'duration': 2000
        });
    },
    showMesasge(msg, type = 'error') {
        if (messageInstance) {
            //如果有已经打开的弹框就先关闭
            // messageInstance.close();
            // messageInstance = null;
        } else {
            messageInstance = ElementUI.Message({
                showClose: true,
                message: msg || '请求出错，请重试',
                type: type,
                duration: 3000,
                onClose: () => {
                    messageInstance = null;
                }

            });
        }
    },
    // post
    post(url, data, isLoading = false) {
        let requestUrl = baseUrl + url;
        return new Promise((resolve, reject) => {
            let req = {
                appVer: config.appVer,
                ver: config.protocolVer,
                reqId: config.reqId,
                param: data || {},
            };
            let loading = {
                configs: {
                    isLoading: isLoading,
                },
            };
            axios
                .post(requestUrl, req, loading)
                .then((response) => {
                    if (response) {
                        resolve(response.data);
                    }
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    // post
    mainPost(url, data, isLoading = false) {
        let requestUrl = url;
        return new Promise((resolve, reject) => {
            let req = {
                appVer: config.appVer,
                ver: config.protocolVer,
                reqId: config.reqId,
                param: data || {},
            };
            let loading = {
                configs: {
                    isLoading: isLoading,
                },
            };
            axios
                .post(requestUrl, req, loading)
                .then((response) => {
                    if (response) {
                        resolve(response.data);
                    }
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    // get
    get(url, params, isLoading = false) {
        let paramsStr = '';
        if (params) {
            paramsStr = params;
        }
        let requestUrl = baseUrl + url + paramsStr;
        let configs = {
            isLoading: isLoading,
        };

        return new Promise((resolve, reject) => {
            axios
                .get(requestUrl, {
                    configs: configs
                })
                .then((response) => {
                    if (response) {
                        resolve(response.data);
                    }
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    // patch
    patch(url, data) {
        let requestUrl = baseUrl + url;
        return new Promise((resolve, reject) => {
            let req = {
                appVer: config.appVer,
                ver: config.protocolVer,
                reqId: config.reqId,
                param: data || {},
            };
            let configs = {
                isLoading: isLoading,
            };
            axios
                .patch(requestUrl, req, configs)
                .then((response) => {
                    resolve(response.data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    //put
    put(url, data, isLoading = false) {
        let requestUrl = baseUrl + url;
        return new Promise((resolve, reject) => {
            let req = {
                appVer: config.appVer,
                ver: config.protocolVer,
                reqId: config.reqId,
                param: data || {},
            };
            let loading = {
                configs: {
                    isLoading: isLoading,
                },
            };
            axios
                .put(requestUrl, req, loading)
                .then((response) => {
                    resolve(response.data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    //putUrl  将请求参数拼接在URL中
    putUrl(url, data, isLoading = false) {
        let requestUrl = baseUrl + url;
        return new Promise((resolve, reject) => {
            let req = data || {};
            let configs = {
                isLoading: isLoading,
            };

            axios
                .put(requestUrl, null, {
                    params: req,
                    configs
                })
                .then((response) => {
                    resolve(response.data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    //delete
    delete(url, params, isLoading = false) {
        let paramsStr = '';
        if (params) {
            paramsStr = params;
        }
        let requestUrl = baseUrl + url + paramsStr;
        let configs = {
            isLoading: isLoading,
        };
        return new Promise((resolve, reject) => {
            axios
                .delete(requestUrl, {
                    configs: configs
                })
                .then((response) => {
                    resolve(response.data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    },
    //deleteArray
    deleteArray(url, params, isLoading = false) {
        let requestUrl = baseUrl + url;
        return new Promise((resolve, reject) => {
            let req = {
                appVer: config.appVer,
                ver: config.protocolVer,
                reqId: config.reqId,
                clientCode: 'string',
                operator: 'string',
                param: params || {},
            };

            let configs = {
                isLoading: isLoading,
            };
            axios
                .delete(requestUrl, {
                    data: req,
                    configs
                })
                .then((response) => {
                    resolve(response.data);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }
};